package api.dataclasses


data class Session (
    val username: String,
    val owner: String,
    val token: String,
    val refreshToken: String,
)